//
//  SDKDocsEntityType.ts
//  Supernova SDK
//
//  Created by Jiri Trecak.
//
// --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
// MARK: - Entity type enum
export var DocsEntityType;
(function (DocsEntityType) {
    DocsEntityType["group"] = "Group";
    DocsEntityType["page"] = "Page";
})(DocsEntityType || (DocsEntityType = {}));
